import { io } from "socket.io-client";

let socket = io(process.env.REACT_APP_WS_URL || "", {
  autoConnect: false,
  reconnectionDelay: 10000,
  auth: (cb) => {
    cb({
      token: localStorage.getItem("accessToken"),
    });
  },
});

let byBitSocket = io(process.env.REACT_APP_BYBIT_WS || "", {
  autoConnect: false,
  reconnectionDelay: 10000,
  auth: (cb) => {
    cb({
      token: localStorage.getItem("accessToken"),
    });
  },
});

export { socket, byBitSocket };
